import { FC, memo } from 'react'
import clsx from 'clsx'
import { Globe } from 'react-feather'

import { Select, Option, useSEOCountriesJSON } from '@pepper/ui'

import styles from './CountrySelector.module.css'

const CountrySelector: FC<{
  value: SEOCountries | undefined
  setValue: (value: SEOCountries) => void
  disabled?: boolean
  className?: string
  upperCaseValue?: boolean
}> = ({
  value,
  setValue,
  disabled = false,
  className = '',
  upperCaseValue = false,
}) => {
  const { data: countries } = useSEOCountriesJSON()

  return (
    <Select<SEOCountries>
      showSearch={true}
      onChange={setValue}
      value={value}
      className={clsx(styles.countrySelectWrapper, className)}
      disabled={disabled}
      placeholder={
        <div className={styles.countrySelectorPlaceholder}>
          <Globe size={16} className={styles.placeholderIcon} />
          <span className={styles.placeholderText}>Choose Country</span>
        </div>
      }
      optionFilterProp="label"
      dropdownMatchSelectWidth={200}
    >
      {countries &&
        Object.values(countries).map((country: SEOCountryData) => {
          return (
            <Option
              key={country.value}
              value={
                upperCaseValue ? country.value.toUpperCase() : country.value
              }
              label={country.label}
            >
              <div className={styles.countryOptionWrapper}>
                <div className={styles.flagContainer}>
                  <img
                    src={country.flag}
                    alt={country.label}
                    width={20}
                    height={16}
                  />
                </div>
                <div>{country.label}</div>
              </div>
            </Option>
          )
        })}
    </Select>
  )
}

export default memo(CountrySelector)
